import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { GlobalSchemaOrg } from "./components/SEO";
import HomePage from "./pages/HomePage";
import CategoriesPage from "./pages/CategoriesPage";
import ContactPage from "./pages/ContactPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import ConfidentialitePage from "./pages/ConfidentialitePage";
import ProprieteIntellectuellePage from "./pages/ProprieteIntellectuellePage";
import BlogPage from "./pages/BlogPage";
import BlogArticlePage from "./pages/BlogArticlePage";
import BlogSubmitPage from "./pages/BlogSubmitPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminOrdersPage from "./pages/admin/AdminOrdersPage";
import AdminSuppliersPage from "./pages/admin/AdminSuppliersPage";
import AdminClicksPage from "./pages/admin/AdminClicksPage";
import AdminBlogPage from "./pages/admin/AdminBlogPage";
import AdminBlogEditorPage from "./pages/admin/AdminBlogEditorPage";
import { CookieBanner } from "./components/CookieBanner";
import { ThemeProvider } from "./lib/theme";
import { AdminAuthProvider, ProtectedAdminRoute } from "./lib/adminAuth";

function App() {
  const [historyOpen, setHistoryOpen] = useState(false);

  return (
    <HelmetProvider>
      <ThemeProvider>
        <BrowserRouter>
          <AdminAuthProvider>
            <div className="App min-h-screen overflow-x-hidden bg-noise">
              <GlobalSchemaOrg />
              <Toaster
                theme="dark"
                position="top-right"
                toastOptions={{
                  style: {
                    background: "#0f172a",
                    border: "1px solid rgba(51, 65, 85, 0.6)",
                    color: "#f1f5f9",
                  },
                }}
              />

              <Header onOpenHistory={() => setHistoryOpen(true)} />

              <Routes>
                <Route
                  path="/"
                  element={
                    <HomePage
                      historyOpen={historyOpen}
                      onCloseHistory={setHistoryOpen}
                    />
                  }
                />
                <Route path="/categories" element={<CategoriesPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
                <Route
                  path="/politique-confidentialite"
                  element={<ConfidentialitePage />}
                />
                <Route
                  path="/propriete-intellectuelle"
                  element={<ProprieteIntellectuellePage />}
                />
                <Route path="/blog" element={<BlogPage />} />
                <Route path="/blog/soumettre" element={<BlogSubmitPage />} />
                <Route path="/blog/:slug" element={<BlogArticlePage />} />
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route
                  path="/admin"
                  element={
                    <ProtectedAdminRoute>
                      <AdminLayout />
                    </ProtectedAdminRoute>
                  }
                >
                  <Route index element={<AdminDashboardPage />} />
                  <Route path="commandes" element={<AdminOrdersPage />} />
                  <Route path="fournisseurs" element={<AdminSuppliersPage />} />
                  <Route path="clics" element={<AdminClicksPage />} />
                  <Route path="blog" element={<AdminBlogPage />} />
                  <Route path="blog/nouveau" element={<AdminBlogEditorPage />} />
                  <Route path="blog/edit/:id" element={<AdminBlogEditorPage />} />
                </Route>
              </Routes>

              <Footer />
              <CookieBanner />
            </div>
          </AdminAuthProvider>
        </BrowserRouter>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
